var exports = {
  "wx": "x234b8571--0d1fbd--header",
  "Ex": "x234b8571--0d1fbd--header--fixed",
  "C$": "x234b8571--0d1fbd--nav",
  "Qs": "x234b8571--0d1fbd--content",
  "DD": "x234b8571--0d1fbd--title",
  "vR": "x234b8571--0d1fbd--tabs",
  "ne": "x234b8571--0d1fbd--controls",
  "wm": "x234b8571--0d1fbd--logo",
};

module.exports = exports;
